/**
	 * 紐付設定画面のデータを取得するために使用するVO
	 */
export class RelatedDataModel {

  // Ｐコード

  // 項番2473 START 連合会問合せNo.997対応
  // 編集前Pコード
  public originPCode: string = <string>'';
  // 項番2473 END   連合会問合せNo.997対応

  public pCode: string = <string>'';

  public enabledPCode: boolean = <boolean>false;

  // 商品名
  public guideGoodsName: string = <string>'';

  // 規格名
  public guideStandardName: string = <string>'';

  // 選択状態（いばらき）
  public selectedIB: boolean = <boolean>false;

  // 選択状態（とちぎ）
  public selectedTO: boolean = <boolean>false;

  // 選択状態（ぐんま）
  public selectedGU: boolean = <boolean>false;

  // 選択状態（ちば）
  public selectedTI: boolean = <boolean>false;

  // 選択状態（さいたま）
  public selectedSA: boolean = <boolean>false;

  // 選択状態（とうきょう）
  public selectedTK: boolean = <boolean>false;

  // 選択状態（ながの）
  public selectedNA: boolean = <boolean>false;

  // 選択状態（にいがた）
  public selectedNI: boolean = <boolean>false;

  // 選択状態（クルコ）
  public selectedKU: boolean = <boolean>false;

  // 活性状態（いばらき）
  public enabledIB: boolean = <boolean>true;

  // 活性状態（とちぎ）
  public enabledTO: boolean = <boolean>true;

  // 活性状態（ぐんま）
  public enabledGU: boolean = <boolean>true;

  // 活性状態（ちば）
  public enabledTI: boolean = <boolean>true;

  // 活性状態（さいたま）
  public enabledSA: boolean = <boolean>true;

  // 活性状態（とうきょう）
  public enabledTK: boolean = <boolean>true;

  // 活性状態（ながの）
  public enabledNA: boolean = <boolean>true;

  // 活性状態（にいがた）
  public enabledNI: boolean = <boolean>true;

  // 活性状態（クルコ）
  public enabledKU: boolean = <boolean>true;
}